var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-absolute h-100 w-100"},[_c('Header'),_c('iframe',{attrs:{"id":"bridge","allow":"microphone;geolocation"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }